import { libidoBeluga } from './Initial/flow';

const libidoFlows = {
  libidoBeluga
};
export default libidoFlows;
